const getPaths = (nestedObj: NavbarCategory[], key: string, cb: (c: NavbarCategory) => boolean) => {
  if (!nestedObj) {
    return [];
  }

  const paths: any[] = [];
  const parentPath: any[] = [];

  return (function deepCheck(items) {
    if (!items?.length) {
      return [];
    }

    if (Array.isArray(items)) {
      items.forEach((item) => {
        parentPath.push(item);
        if (cb(item)) {
          paths.push([...parentPath]);
        }

        if (item[key]) {
          deepCheck(item[key]);
        }
        parentPath.pop();
      });
    }

    return paths[0];
  }(nestedObj));
};

export interface CategoryBreadCrumbs {
  count: number;
  id: string;
  isCurrent: boolean;
  items: CategoryBreadCrumbs[];
  slug: string;
  name: string;
  slugAllLocales: any;
  canonicalUrl: string;
  label: string;
  metaTitle: string;
  metaDescription: string;
  headlineTitle: string;
  categoryDescription: string;
  isHidden: boolean;
  saleMetadata: {
    metaTitle?: string;
    metaDescription?: string;
    headline?: string;
    description?: string;
  };
  redirectionRules: {
    statusCode: number;
    redirectUrl: string;
  };
}

export default (categoryTree: NavbarCategory[], property: any, value: string): CategoryBreadCrumbs[] => {
  if (!categoryTree) {
    return [];
  }

  return getPaths(categoryTree, 'childrenItems', (cat: string) => cat[property] === value);
};
